// extracted by css-extract-rspack-plugin
export default {"layoutNavLink":"layoutNavLink__dfs7F","layoutNavLink__icon":"layoutNavLink__icon__KJAjf","layoutNavLink_active":"layoutNavLink_active__IpRks"};